import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c6a6882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "VATReturns" }
const _hoisted_2 = {
  key: 0,
  class: "content-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "tabs-content-container"
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "tabs-content" }
const _hoisted_8 = { class: "center-dropdown-table-container" }
const _hoisted_9 = { class: "center-dropdown-table" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", null, "Search for Journal Reference:")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", null, "Search for Invoice by Date:")
], -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Filter VAT Returns by Journal Type:", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  title: "Search for invoices to view and download by journal reference",
  class: "search-with-button",
  style: {"padding-left":"1rem","padding-right":"1rem"}
}
const _hoisted_16 = ["onKeyup"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  class: "search-with-button",
  style: {"padding-left":"1rem","padding-right":"1rem","width":"100%"}
}
const _hoisted_20 = {
  class: "embedded-dropdown",
  style: {"justify-content":"center","width":"100%"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}, " Select Journal Type... ", -1))
const _hoisted_22 = { value: "" }
const _hoisted_23 = ["id", "value"]
const _hoisted_24 = {
  class: "center-buttons",
  style: {"margin-top":"0"}
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = ["disabled"]
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { style: {"vertical-align":"middle"} }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { style: {"font-weight":"normal !important"} }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { style: {"font-weight":"normal !important"} }
const _hoisted_34 = {
  key: 1,
  class: "center-buttons",
  style: {"margin-top":"0"}
}
const _hoisted_35 = {
  class: "incident-nav-button-fake",
  style: {"margin-left":"0.7rem"}
}

import { ref, Ref, onMounted, provide, inject, watch } from "vue";
// Components
import VATReturnsTabs from "@/components/VATReturns/VATReturnsTabs.vue";
import VATReturnsTables from "@/components/VATReturns/VATReturnsTables.vue";
import VATReturnsDatePicker from "@/components/VATReturns/VATReturnsDatePicker.vue";
// Services
import { IAPILogger } from "@/interfaces/IAPILogger";
import { MonetaryValueWithCommas } from "@/services/helpers/Helper";
import VATReturnsServices from "@/services/helpers/VATReturns/VATReturnsHelper";
import {
    VATReturns,
    displayedVATReturns,
    displayAmountVATTotal,
    isLoading,
    journalReference,
    invalidJournalReferences,
    validJournalReferences,
    infoError,
    tabs,
    currentTab,
    journalTypeSelection,
    isDateSearch,
    dateRange,
    journalTypeSelectionDate
} from "@/services/helpers/VATReturns/VATReturnsVariables";
import {
    ValidateJournalReferences,
    FilterVATReturns,
    DisplayVATReturns,
    DisplayVATReturnsNotFound,
    GetTabJournalingTypes,
} from "@/services/helpers/VATReturns/VATReturnsFunctions";
// Data
import IJournalVATResponse from "@/interfaces/VATReturns/IJournalVATResponse";
import INotFoundError from "@/Interfaces/Errors/INotFoundError";
import JournalVAT from "@/models/VATReturns/JournalVat";
// Misc
import log from "loglevel";
import { AxiosError } from "axios";
import "@vuepic/vue-datepicker/dist/main.css";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const fileName = "VATReturns.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'VATReturns',
  setup(__props) {

const page: Ref<number> = ref(1);
const rowCount: Ref<number> = ref(50);
provide("page", page);
provide("rowCount", rowCount);

const Logger: IAPILogger = inject("Logger")!;

const journalSearchInput: Ref<any> = ref();
const journalSearchButton: Ref<any> = ref();

const downloadButton: Ref<any> = ref();

watch(
    () => journalTypeSelection.value,
    () => {
        FilterVATReturns();
    }
);

// MISC
const JVATServices: VATReturnsServices = new VATReturnsServices();

onMounted(() => {
    log.trace("onMounted() Invoices");

    document.title = 'Invoices - UV';

    VATReturns.value = [];
    displayedVATReturns.value = [];
});

/*
    Search for comma-separated journal references at once.
*/
function search() {
    /*
        August Long:    JRN_10_CustomerCreditNote, JRN_51_CustomerInvoice, JRN_53_CustomerInvoice, JRN_15_CarSaleInvoice, JRN_44_CustomerInvoice, JRN_25_CustomerInvoice, JRN_26_CustomerInvoice, JRN_38_CustomerInvoice, JRN_9_CustomerCreditNote, JRN_17_CarSaleInvoice, JRN_41_CustomerInvoice, JRN_54_CustomerInvoice, JRN_3_CarSaleCreditNote, JRN_12_CarSaleInvoice, JRN_50_CustomerInvoice, JRN_31_CustomerInvoice, JRN_16_CarSaleInvoice, JRN_49_CustomerInvoice, JRN_INV_3_ServiceInvoice, JRN_36_CustomerInvoice, JRN_8_CustomerCreditNote, JRN_9_CarSaleInvoice, JRN_14_CarSaleInvoice, JRN_33_CustomerInvoice, JRN_47_CustomerInvoice, JRN_1_CarSaleCreditNote, JRN_6_CustomerCreditNote, JRN_34_CustomerInvoice, JRN_48_CustomerInvoice, JRN_45_CustomerInvoice, JRN_52_CustomerInvoice, JRN_30_CustomerInvoice, JRN_28_CustomerInvoice, JRN_46_CustomerInvoice, JRN_39_CustomerInvoice, JRN_7_CustomerCreditNote, JRN_4_CarSaleInvoice, JRN_11_CarSaleInvoice, JRN_37_CustomerInvoice, JRN_40_CustomerInvoice, JRN_55_CustomerInvoice, JRN_42_CustomerInvoice, JRN_29_CustomerInvoice, JRN_6_CarSaleInvoice, JRN_22_CustomerInvoice, JRN_7_CarSaleInvoice, JRN_8_CarSaleInvoice, JRN_35_CustomerInvoice, JRN_5_CarSaleInvoice, JRN_5_CustomerCreditNote, JRN_25_CarSaleInvoice, JRN_13_CarSaleInvoice, JRN_24_CustomerInvoice, JRN_32_CustomerInvoice, JRN_43_CustomerInvoice, JRN_10_CarSaleInvoice, JRN_23_CustomerInvoice, JRN_27_CustomerInvoice, JRN_2_CarSaleCreditNote
        August Short:   JRN_13_CustomerInvoice, JRN_10_CustomerInvoice, JRN_14_CustomerInvoice, JRN_12_CustomerInvoice, JRN_17_CustomerInvoice, JRN_INV_1_ServiceInvoice, JRN_16_CustomerInvoice, JRN_15_CustomerInvoice, JRN_2_CustomerCreditNote, JRN_11_CustomerInvoice, JRN_18_CustomerInvoice, JRN_21_CustomerInvoice, JRN_3_CustomerCreditNote, JRN_9_CustomerInvoice, JRN_4_CustomerCreditNote, JRN_19_CustomerInvoice, JRN_1_CustomerCreditNote
    
        JRN_6_CustomerCreditNote, JRN_26_CustomerInvoice, JRN_38_CustomerInvoice, JRN_45_CustomerInvoice, JRN_24_CustomerInvoice, JRN_7_CarSaleInvoice, JRN_46_CustomerInvoice, JRN_14_CarSaleInvoice, JRN_6_CarSaleInvoice, JRN_16_CarSaleInvoice, JRN_8_CarSaleInvoice, JRN_5_CarSaleInvoice, JRN_9_CustomerCreditNote, JRN_31_CustomerInvoice, JRN_30_CustomerInvoice, JRN_37_CustomerInvoice, JRN_39_CustomerInvoice, JRN_55_CustomerInvoice, JRN_22_CustomerInvoice, JRN_2_CarSaleCreditNote, JRN_15_CarSaleInvoice, JRN_5_CustomerCreditNote, JRN_49_CustomerInvoice, JRN_INV_3_ServiceInvoice, JRN_23_CustomerInvoice, JRN_28_CustomerInvoice, JRN_17_CarSaleInvoice, JRN_11_CarSaleInvoice, JRN_44_CustomerInvoice, JRN_48_CustomerInvoice, JRN_51_CustomerInvoice, JRN_35_CustomerInvoice, JRN_4_CarSaleInvoice, JRN_7_CustomerCreditNote, JRN_33_CustomerInvoice, JRN_8_CustomerCreditNote, JRN_1_CarSaleCreditNote, JRN_9_CarSaleInvoice, JRN_10_CustomerCreditNote, JRN_3_CarSaleCreditNote, JRN_10_CarSaleInvoice, JRN_41_CustomerInvoice, JRN_52_CustomerInvoice, JRN_29_CustomerInvoice, JRN_54_CustomerInvoice, JRN_42_CustomerInvoice, JRN_27_CustomerInvoice, JRN_12_CarSaleInvoice, JRN_53_CustomerInvoice, JRN_40_CustomerInvoice, JRN_36_CustomerInvoice, JRN_25_CarSaleInvoice, JRN_13_CarSaleInvoice, JRN_34_CustomerInvoice, JRN_50_CustomerInvoice, JRN_43_CustomerInvoice, JRN_32_CustomerInvoice, JRN_47_CustomerInvoice, JRN_25_CustomerInvoice
        JRN_6_CarSaleInvoice, JRN_1_RechargeInvoice, JRN_1_ServiceInvoice, JRN_INV_1_ServiceInvoice, JRN_INV_9_ServiceInvoice, JRN_4_CustomerInvoice, JRN_5_CustomerInvoice, JRN_6_CustomerCreditNote, JRN_29_CustomerCreditNote, JRN_1_CarSaleCreditNote, JRN_5_CarSaleCreditNote, JRN_80_CustomerInvoice

        ERROR: ERROR_JRN_6_CarSaleInvoice, ERROR_JRN_1_RechargeInvoice, ERRORJRN_1_ServiceInvoice, JRN_INV_1ERROR_ServiceInvoice, JRN_INV_9_ServiceInvoice, JRN_4_ERRORCustomerInvoice, JRN_5_CustomerInvoice, JRN_6_CustomerCreditNote, JRN_29_CustomerCreditNote, JRN_1_CarSaleCreditNote, JRN_5_CarSaleCreditNote, JRN_80_CustomerInvoice
     */
    // Logging
    const name = "search";
    log.trace(`${name}{}`);

    const delimeter: string = "\r\n        ";
    journalReference.value = journalReference.value.replaceAll(" ", "");
    var journalReferences: string[] = journalReference.value
        .split(",")
        .map((ref: string) => ref + ",");

    // Remove trailing comma
    if (journalReferences[journalReferences.length - 1].endsWith(",")) {
        journalReferences[journalReferences.length - 1] = journalReferences[
            journalReferences.length - 1
        ].slice(0, -1);
    }

    // Updates <invalidJournalReferences> and <validJournalReferencesByJournalType>
    ValidateJournalReferences(journalReferences);

    if (invalidJournalReferences.value.length) {
        var invalids: string = delimeter + invalidJournalReferences.value.join(delimeter);
        // Remove trailing comma
        if (invalids.endsWith(",")) invalids = invalids.slice(0, -1);
        invalids = invalids + "\r\n\r\nPlease try again.";

        useNotifierWithErrFormatter().warn({msg: "The following references were invalid: " + invalids})
    } else {
        var query: string = delimeter + journalReferences.join(delimeter);
        // Remove trailing comma
        if (query.endsWith(",")) query = query.slice(0, -1);

        log.trace(`search()\nSearching for ${journalReference.value}`);
        SearchForJournalReference();
        currentTab.value = tabs.Summary;
    }
}

async function SearchForJournalReference() {
    isLoading.value = true;
    isDateSearch.value = false;
    dateRange.value = undefined;
    journalTypeSelectionDate.value = "";

    const name = SearchForJournalReference.name;
    const prefix = `${name}()\n`;
    const Class = fileName + "/" + name;
    var Message = `Searching for Invoices files (Journal Reference: ${journalReference.value}).`;

    log.trace(prefix + Message);
    await JVATServices.GetVATReturnsFromJournalReferences(journalReference.value)
        .then((response: IJournalVATResponse) => {
            log.trace("SearchForJournalReference() Response:", response);
            DisplayVATReturns(response);

            displayAmountVATTotal.value = (displayedVATReturns.value ?? []).reduce((partialSum: number, vatReturn: JournalVAT) => {
                log.trace(prefix + "vatReturn:", vatReturn, "\nJournalVATMetaData:", vatReturn.JournalVATMetaData);
                for (const metadata of vatReturn.JournalVATMetaData.AccountingMetaData) {
                    partialSum += metadata.IsIncrease
                        ? (metadata.UseAmountVAT ? vatReturn.AmountVat : vatReturn.AmountExVat)
                        : - (metadata.UseAmountVAT ? vatReturn.AmountVat : vatReturn.AmountExVat)
                }
                return partialSum;
            }, 0);

            Logger.LogInformation(Message, Class);
        })
        .catch((error: any) => {
            if (error instanceof AxiosError && error.response?.status == 400) {
                DisplayVATReturnsNotFound(error as INotFoundError);
            } else {
                if (error instanceof AxiosError) {
                    isLoading.value = false;
                    useNotifierWithErrFormatter().error({error, errorType: "Getting VAT Returns"});
                    infoError.value = true;
                }
                Message = `(Error) ${Message}: ${error instanceof AxiosError ? error : error.message
                    }`;
                log.error(Message);
                Logger.LogError(Message, Class);
            }
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(VATReturnsTabs),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("table", _hoisted_9, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_10,
                      _hoisted_11,
                      (_unref(currentTab) != _unref(tabs).Summary && !_unref(isDateSearch))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_12, _hoisted_14))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_15, [
                          _withDirectives(_createElementVNode("input", {
                            ref_key: "journalSearchInput",
                            ref: journalSearchInput,
                            type: "text",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(journalReference) ? (journalReference).value = $event : null)),
                            placeholder: "Enter comma-separated Journal References...",
                            onKeyup: _withKeys(search, ["enter"]),
                            style: {"width":"100%"}
                          }, null, 40, _hoisted_16), [
                            [_vModelText, _unref(journalReference)]
                          ]),
                          _createElementVNode("button", {
                            ref_key: "journalSearchButton",
                            ref: journalSearchButton,
                            onClick: search,
                            disabled: _unref(journalReference).trim().length < 1,
                            class: "right-button"
                          }, " Search ", 8, _hoisted_17)
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(VATReturnsDatePicker)
                      ]),
                      (_unref(currentTab) != _unref(tabs).Summary && !_unref(isDateSearch))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(journalTypeSelection) ? (journalTypeSelection).value = $event : null)),
                                  style: {"width":"100%","margin-top":"0px"}
                                }, [
                                  _hoisted_21,
                                  _createElementVNode("option", _hoisted_22, _toDisplayString(`${_unref(journalTypeSelection)
                                                                ? "All Journal Types"
                                                                : "Select Journal Type..."
                                                                }`), 1),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GetTabJournalingTypes)().sort((a, b) =>
                                                        a.Canonical.localeCompare(
                                                            b.Canonical
                                                        )
                                                    ), (jType) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      id: _unref(currentTab).toString(),
                                      value: jType.Canonical,
                                      key: jType.Canonical
                                    }, _toDisplayString(jType.DisplayShort), 9, _hoisted_23))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, _unref(journalTypeSelection)]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_24, [
                          (_unref(currentTab) != _unref(tabs).Summary)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                ref_key: "downloadButton",
                                ref: downloadButton,
                                class: "incident-nav-button",
                                disabled: !_unref(displayedVATReturns)?.length,
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(JVATServices).DownloadVATReturnsData()))
                              }, [
                                _createElementVNode("div", null, " Export Box " + _toDisplayString(_unref(currentTab)) + " data to CSV ", 1)
                              ], 8, _hoisted_25))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            ref_key: "downloadButton",
                            ref: downloadButton,
                            class: "incident-nav-button",
                            style: {"margin-left":"1rem"},
                            disabled: !_unref(displayedVATReturns)?.length,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(JVATServices).DownloadVATReturnsData(true)))
                          }, " Export all data to CSV ", 8, _hoisted_26)
                        ])
                      ]),
                      (_unref(currentTab) != _unref(tabs).Summary && !_unref(isDateSearch))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_27))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_28, [
                        (_unref(currentTab) == _unref(tabs).Summary)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                              (_unref(validJournalReferences).length)
                                ? (_openBlock(), _createElementBlock("details", _hoisted_30, [
                                    _createElementVNode("summary", null, " View " + _toDisplayString(_unref(validJournalReferences).length) + " Journal References: ", 1),
                                    _createElementVNode("body", _hoisted_31, _toDisplayString(_unref(validJournalReferences).join(' ')), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_unref(invalidJournalReferences).length)
                                ? (_openBlock(), _createElementBlock("details", _hoisted_32, [
                                    _createElementVNode("summary", null, " View " + _toDisplayString(_unref(invalidJournalReferences).length) + " Invalid Journal References: ", 1),
                                    _createElementVNode("body", _hoisted_33, _toDisplayString(_unref(invalidJournalReferences).join(' ')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _createTextVNode(_toDisplayString((_unref(currentTab) == _unref(tabs).Box6 || _unref(currentTab) == _unref(tabs).Box7)
                                                ? 'Amount Ex. VAT Total:'
                                                : 'Amount VAT Total:') + " ", 1),
                              _createElementVNode("button", _hoisted_35, _toDisplayString(_unref(MonetaryValueWithCommas)((Math.round(_unref(displayAmountVATTotal) * 100) /
                                                    100))), 1)
                            ]))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode(VATReturnsTables)
        ]))
  ]))
}
}

})